/* ============================================================
   SIDVION — storefront behaviour
   Mirrors the interactions specified in the artboards:
   rail snapping, card hover, gallery, accordion, qty, cart.
   ============================================================ */
(function () {
  'use strict';

  var routes = window.routes || {};
  var money = window.svMoneyFormat || '₹{{amount_no_decimals}}';

  function formatMoney(cents) {
    var n = (cents || 0) / 100;
    var s = n % 1 === 0 ? String(Math.round(n)) : n.toFixed(2);
    // Indian digit grouping: 1,23,456
    var parts = s.split('.');
    var i = parts[0];
    var last3 = i.slice(-3);
    var rest = i.slice(0, -3);
    if (rest) last3 = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + last3;
    return '₹' + last3 + (parts[1] ? '.' + parts[1] : '');
  }
  window.svFormatMoney = formatMoney;

  /* ---------- toast ---------------------------------------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'sv-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  /* ---------- cart count ----------------------------------- */
  function refreshCount() {
    fetch(routes.cart_url ? routes.cart_url + '.js' : '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-sv-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count ? '' : 'none';
        });
      })
      .catch(function () { /* offline — leave the badge as rendered */ });
  }

  /* ---------- add to cart ---------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sv-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-sv-add');
    if (!id) return;
    var qtyInput = btn.closest('form, .sv-pdp__info');
    var qty = 1;
    if (qtyInput) {
      var qi = qtyInput.querySelector('[data-sv-qty-input]');
      if (qi) qty = parseInt(qi.value, 10) || 1;
    }
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'ADDING…';

    fetch(routes.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        btn.disabled = false;
        btn.textContent = label;
        if (!res.ok) { toast(res.d.description || 'Could not add that.'); return; }
        toast('Added to bag');
        refreshCount();
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = label;
        toast('Could not add that.');
      });
  });

  /* ---------- quantity steppers ---------------------------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-sv-step]');
    if (!step) return;
    var wrap = step.closest('.sv-qty');
    if (!wrap) return;
    var input = wrap.querySelector('input');
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var next = (parseInt(input.value, 10) || min) + parseInt(step.getAttribute('data-sv-step'), 10);
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- cart line changes ---------------------------- */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-sv-line-qty]');
    if (!input) return;
    updateLine(input.getAttribute('data-sv-line-qty'), parseInt(input.value, 10) || 0);
  });
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-sv-line-remove]');
    if (!rm) return;
    e.preventDefault();
    updateLine(rm.getAttribute('data-sv-line-remove'), 0);
  });
  function updateLine(line, quantity) {
    fetch(routes.cart_change_url || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: quantity })
    }).then(function () { window.location.reload(); });
  }

  /* ---------- occasion rail -------------------------------- */
  document.querySelectorAll('[data-sv-rail]').forEach(function (rail) {
    var cards = Array.prototype.slice.call(rail.querySelectorAll('.sv-rail__card'));
    if (!cards.length) return;
    var cardW = cards[0].offsetWidth || 292;
    var current = 0;
    var painted = false;

    function padLeft() {
      return parseFloat(getComputedStyle(rail).paddingLeft) || 0;
    }

    /* offsetLeft is measured from .sv-rail-wrap, because the rail itself
       is position:static — it is not a scroll-space coordinate. Using it
       as a scroll target overshot badly (card 3 computed 876 against a
       max scroll of 471) and scroll-snap bounced the rail back to 0.
       Measure each card against the rail's own box instead. */
    function cardOffset(n) {
      return cards[n].getBoundingClientRect().left
           - rail.getBoundingClientRect().left
           + rail.scrollLeft - padLeft();
    }

    function maxScroll() {
      return Math.max(0, rail.scrollWidth - rail.clientWidth);
    }

    /* The card whose leading edge sits nearest the rail's scroll position. */
    function activeIndex() {
      var best = 0, bestD = Infinity;
      for (var n = 0; n < cards.length; n++) {
        var d = Math.abs(cardOffset(n) - rail.scrollLeft);
        if (d < bestD) { bestD = d; best = n; }
      }
      return best;
    }

    var wrap = rail.closest('.sv-rail-wrap');
    var section = wrap ? wrap.parentNode : rail.parentNode;
    var dotWrap = section ? section.querySelector('[data-sv-rail-dots]') : null;
    var dots = [];

    function goTo(n) {
      n = Math.max(0, Math.min(cards.length - 1, n));
      /* Clamp, or a target past the end snaps straight back to where it was. */
      var left = Math.max(0, Math.min(cardOffset(n), maxScroll()));
      /* Measured: scrollTo({behavior:'smooth'}) is cancelled outright by
         scroll-snap-type: x mandatory (scrollLeft stayed 0), while a direct
         assignment moved the rail — provided scroll-behavior stays auto. */
      rail.scrollLeft = left;
      /* Measured: assigning scrollLeft does not emit a scroll event here
         (zero events after an 800ms wait), so the scroll listener alone
         left the highlight stuck on the first card. Paint directly, then
         again once scroll-snap has settled the final position. */
      track();
      setTimeout(track, 260);
    }

    if (dotWrap && !dotWrap.children.length) {
      cards.forEach(function (c, n) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'sv-rail__dot';
        d.setAttribute('aria-label', 'Go to slide ' + (n + 1));
        d.addEventListener('click', function () { goTo(n); });
        dotWrap.appendChild(d);
        dots.push(d);
      });
    }

    function track() {
      var i = activeIndex();
      /* The first card ships with .is-active from Liquid, so the old
         guard skipped the very first paint and the dots never lit. */
      if (!painted || i !== current) {
        painted = true;
        current = i;
        cards.forEach(function (c, n) { c.classList.toggle('is-active', n === i); });
        dots.forEach(function (d, n) {
          d.classList.toggle('is-on', n === i);
          d.setAttribute('aria-selected', n === i ? 'true' : 'false');
        });
      }
    }

    rail.addEventListener('scroll', track, { passive: true });
    window.addEventListener('resize', function () {
      cardW = cards[0].offsetWidth || cardW;
      track();
    });
    track();

    if (!wrap) return;
    wrap.querySelectorAll('[data-sv-rail-nav]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        goTo(current + parseInt(btn.getAttribute('data-sv-rail-nav'), 10));
      });
    });
  });

  /* ---------- product gallery ------------------------------ */
  document.querySelectorAll('[data-sv-gallery]').forEach(function (g) {
    var stage = g.querySelector('[data-sv-gallery-stage]');
    g.querySelectorAll('[data-sv-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-sv-gallery-thumb');
        if (stage && src) stage.setAttribute('src', src);
        g.querySelectorAll('[data-sv-gallery-thumb]').forEach(function (o) { o.classList.remove('is-active'); });
        t.classList.add('is-active');
        var count = g.querySelector('[data-sv-gallery-count]');
        var idx = t.getAttribute('data-sv-gallery-index');
        if (count && idx) {
          count.textContent = idx + ' / ' + g.querySelectorAll('[data-sv-gallery-thumb]').length;
        }
      });
    });
  });

  /* ---------- accordion ------------------------------------ */
  document.querySelectorAll('[data-sv-acc]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var body = document.getElementById(btn.getAttribute('aria-controls'));
      if (!body) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      body.hidden = open;
      var sign = btn.querySelector('.sv-acc__sign');
      if (sign) sign.textContent = open ? '+' : '−';
    });
  });

  /* ---------- variant picker ------------------------------- */
  document.querySelectorAll('[data-sv-variants]').forEach(function (root) {
    var data = {};
    try { data = JSON.parse(root.getAttribute('data-sv-variants')); } catch (err) { return; }
    root.querySelectorAll('[data-sv-variant]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-sv-variant');
        var v = data[id];
        root.querySelectorAll('[data-sv-variant]').forEach(function (o) { o.classList.remove('is-active'); });
        btn.classList.add('is-active');

        var addBtn = document.querySelector('[data-sv-add]');
        if (addBtn) {
          addBtn.setAttribute('data-sv-add', id);
          addBtn.disabled = !v || !v.available;
          /* The price is shown once, above the buy row — the button only
             ever states the action. */
          addBtn.textContent = (v && v.available) ? 'ADD TO BAG' : 'SOLD OUT';
        }
        var priceEl = document.querySelector('[data-sv-price]');
        if (priceEl && v) priceEl.textContent = formatMoney(v.price);
        var wasEl = document.querySelector('[data-sv-was]');
        if (wasEl) {
          if (v && v.compare_at_price && v.compare_at_price > v.price) {
            wasEl.textContent = formatMoney(v.compare_at_price);
            wasEl.hidden = false;
          } else { wasEl.hidden = true; }
        }
        var saveEl = document.querySelector('.sv-pdp__save');
        if (saveEl) {
          if (v && v.compare_at_price && v.compare_at_price > v.price) {
            saveEl.textContent = 'PRICE DROP · SAVE ' + formatMoney(v.compare_at_price - v.price);
            saveEl.hidden = false;
          } else { saveEl.hidden = true; }
        }
        if (window.history.replaceState && v) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', id);
          window.history.replaceState({}, '', u);
        }
      });
    });
  });

  /* ---------- wishlist (local only) ------------------------ */
  var WISH = 'sv_wishlist';
  function readWish() {
    try { return JSON.parse(localStorage.getItem(WISH) || '[]'); } catch (e) { return []; }
  }
  function writeWish(list) {
    try { localStorage.setItem(WISH, JSON.stringify(list)); } catch (e) { /* private mode */ }
  }
  var wished = readWish();
  document.querySelectorAll('[data-sv-wish]').forEach(function (btn) {
    var h = btn.getAttribute('data-sv-wish');
    var on = wished.indexOf(h) !== -1;
    btn.setAttribute('aria-pressed', String(on));
    btn.textContent = on ? '♥' : '♡';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      wished = readWish();
      var i = wished.indexOf(h);
      if (i === -1) { wished.push(h); } else { wished.splice(i, 1); }
      writeWish(wished);
      var nowOn = wished.indexOf(h) !== -1;
      btn.setAttribute('aria-pressed', String(nowOn));
      btn.textContent = nowOn ? '♥' : '♡';
    });
  });

  /* ---------- mobile nav ----------------------------------- */
  document.querySelectorAll('[data-sv-burger]').forEach(function (b) {
    b.addEventListener('click', function () {
      var header = b.closest('.sv-header');
      if (!header) return;
      var open = header.classList.toggle('is-open');
      b.setAttribute('aria-expanded', String(open));
    });
  });

  refreshCount();
})();
